import styled from 'styled-components'

import { Cover } from '@/lib/mixins'

export const SummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
`

export const SummaryComposition = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
`

export const SummaryCompositionText = styled.h2`
  font-family: ${props => props.theme.font.secondary};
  font-size: 320px;
  opacity: 0.05;
  line-height: 320px;
`

export const SummaryCompositionImagesWrapper = styled.div`
  ${Cover()}
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  margin-top: -8%;
  gap: 96px;
`

export const SummaryCompositionImage = styled.img`
  margin-top: ${props => (props.padded ? '20%' : '0')};
  width: 340px;
  height: 340px;
  object-fit: cover;
`

export const SummaryTitle = styled.h2`
  font-family: ${props => props.theme.font.secondary};
  font-size: 128px;
  margin-bottom: 32px;
  margin-top: -10%;
`

export const SummaryCaption = styled.div`
  font-size: 28px;
  margin-bottom: 42px;
`

export const SummaryAddon = styled.div`
  opacity: 0.5;
  margin-bottom: 42px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-direction: row;
`

export const SummaryAddonIcon = styled.div`
  margin-right: 12px;
  margin-top: -4px;
`

export const SummaryAddonText = styled.div`
  font-size: 24px;
`

export const SummaryNumber = styled.div`
  font-size: 6rem;
  padding: 1rem 2rem;
  border: 2px solid ${props => props.theme.color.global};
  margin-bottom: 42px;
  border-radius: 12px;
`
